export const PLAIN_LINK_TITLE = '\u200c';
